import type { ReactNode } from "react";
import type { PathPattern } from "react-router-dom";

import { Collapse } from "react-bootstrap";
import { useMatch } from "react-router-dom";

interface IPathExpanderProps extends PathPattern {
  children: ReactNode;
  timeout?: number;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
}

function PathExpander({
  children,
  timeout,
  mountOnEnter,
  unmountOnExit,
  ...options
}: IPathExpanderProps) {
  const match = useMatch(options);

  return (
    <Collapse
      timeout={timeout}
      in={!!match}
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
    >
      <div>{children}</div>
    </Collapse>
  );
}

export default PathExpander;
